import React, { useEffect, useRef, useState } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useAllProduct } from "../../api-context/commonApiContext";
import styles from "./header.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = () => {
  const {
    setSelectedEscrowVal,
    setSelectedCompanyName,
    setSelectedEscrowName,
    selectedEscrowVal,
    selectedCompanyName,
    selectedEscrowName, // Make sure this is defined in the context
    filterEscrowVal,
    companyDropdown,
    companyDetails,
    setRole,
    role,
    localStorage,
    escrowEntries,
    setFilterEscrowVal,
    userMail,
    loggedBy,
  } = useAllProduct();

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const iconRef = useRef(null);
  const popupRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  // Toggle popup visibility
  const togglePopup = () => {
    setIsPopupOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setIsPopupOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (companyDropdown.length > 0 && escrowEntries.length > 0) {
      const defaultCompany = companyDropdown[0];
      setSelectedCompanyName(defaultCompany);
      window.localStorage?.setItem("company_name", defaultCompany);

      const matchedEntry = escrowEntries.find(
        (entry) => entry.company_name === defaultCompany
      );

      const defaultEscrow = matchedEntry?.sub_escrow?.[0]?.id || "";
      setFilterEscrowVal(matchedEntry?.sub_escrow || []);
      setSelectedEscrowName(defaultEscrow);
      window.localStorage?.setItem("escrow_name", defaultEscrow);
    }
  }, [companyDropdown, escrowEntries]);
  console.log("location.pathname", location.pathname);

  return (
    <div
      className={`${styles.stickyHeader} d-flex justify-content-end mt-4 px-4`}
    >
      {!location.pathname.includes("escrow-management") ? (
        <>
          <FormControl sx={{ width: "250px", pr: 2 }}>
            <InputLabel id="company-select-label">Select Company</InputLabel>
            <Select
              labelId="company-select-label"
              id="company-select"
              value={selectedCompanyName}
              label="Select Company"
              onChange={(e) => {
                const selected = e.target.value;
                setSelectedCompanyName(selected);
                localStorage?.setItem("company_name", selected);

                const matchedEntry = escrowEntries.find(
                  (entry) => entry.company_name === selected
                );
                const subEscrows = matchedEntry?.sub_escrow || [];
                const defaultEscrowId = subEscrows[0]?.id || "";

                setFilterEscrowVal(subEscrows);
                setSelectedEscrowName(defaultEscrowId);
                localStorage?.setItem("escrow_name", defaultEscrowId);
              }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#79747E", // Change border color
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey", // Change hover border color
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2348AB", // Change focused border color
                },
                ...(loggedBy === "client" && {
                  "& .MuiInputBase-input.Mui-disabled": {
                    cursor: "not-allowed",
                    pointerEvents: "all",
                    backgroundColor: "#F1F1F1",
                    borderRadius: "9px",
                  },
                }),
              }}
              disabled={loggedBy === "client" ? true : false}
            >
              {Array.isArray(companyDropdown) && companyDropdown.length > 0 ? (
                companyDropdown.map((company, index) => (
                  <MenuItem key={index} value={company}>
                    {company}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  No companies available
                </MenuItem>
              )}
            </Select>
          </FormControl>

          <FormControl sx={{ width: "250px", pr: 2 }}>
            <InputLabel id="escrow-select-label">Select Escrow</InputLabel>
            <Select
              labelId="escrow-select-label"
              id="escrow-select"
              value={selectedEscrowName}
              label="Select Escrow"
              onChange={(e) => {
                setSelectedEscrowName(e.target.value);
                localStorage?.setItem("escrow_name", e.target.value);
              }}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#79747E", // Change border color
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "grey", // Change hover border color
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2348AB", // Change focused border color
                },
              }}
            >
              {Array.isArray(filterEscrowVal) && filterEscrowVal.length > 0 ? (
                filterEscrowVal.map((val, index) => (
                  <MenuItem key={index} value={val.id}>
                    {val.id}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  No escrows available
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </>
      ) : (
        ""
      )}
      <div className="position-relative">
        {/* User Icon (Trigger) */}
        <div ref={iconRef} onClick={togglePopup} className="cursor-pointer">
          <img
            className={`${styles.vectorIcon1} dropbtn`}
            alt="User"
            src="/user-circle.svg"
          />
        </div>

        {isPopupOpen && (
          <div
            ref={popupRef}
            className="me-3"
            style={{
              position: "absolute",
              top: "60px",
              right: "0",
              background: "white",
              border: "1px solid #ddd",
              padding: "15px",
              borderRadius: "10px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              zIndex: 51,
              width: "280px",
            }}
          >
            <div className="d-flex align-items-center gap-2 mb-2 w-100">
              <div className={`d-flex align-items-center`}>
                <img src="/user-circle.svg" alt="User" /> &nbsp;{" "}
              </div>
              <div className={`${styles.userName}`}>
                {userMail?.length > 0 && userMail?.split("@")[0]}
              </div>
              <div className={`${styles.role}`}>
                {localStorage?.getItem("user_name") ||
                  companyDetails?.user_name ||
                  role?.toString() ||
                  "User"}
              </div>
            </div>
            <div
              className={`d-flex align-items-center justify-content-center mb-2 ${styles.mail}`}
            >
              {userMail?.length > 0 && userMail}
            </div>
            <hr />
            <div className={styles.logout}>
              <button
                className={styles.contractsList}
                onClick={() => {
                  if (typeof window !== "undefined" && window.localStorage) {
                    window.localStorage.removeItem("role");
                    window.localStorage.removeItem("loggedBy");
                    window.localStorage.removeItem("userMail");
                    window.localStorage.removeItem("clientId");
                    window.localStorage.removeItem("user_id");
                    window.localStorage.removeItem("client_company_name");
                    window.localStorage.removeItem("makerLimit");
                    window.localStorage.removeItem("approverLimit");
                    window.localStorage.removeItem("company_name");
                    window.localStorage.removeItem("escrow_name");
                  }

                  setRole("");
                  navigate("/");
                }}
              >
                <img
                  className={styles.building07Icon}
                  alt=""
                  src="/box-arrow-right.svg"
                />
                <div className={`${styles.kycList1} px-2`}>Logout</div>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
